import {IDrawPredictorStore} from "apps/DRAW_PREDICTOR/modules/types/store";
import {keyBy, map, random} from "lodash";
import {createSelector} from "reselect";
import {getFanFactSquadId} from "apps/DRAW_PREDICTOR/modules/selectors/modals";
import {RequestState} from "modules";

export const getSupportedCountries = (state: IDrawPredictorStore) =>
	map(state.projectJsons.supportedCountries, (value, key) => {
		return {
			key,
			value,
		};
	});

export const getFanSentiments = (state: IDrawPredictorStore) => state.projectJsons.fanSentiments;
export const getDrawPredictorSettings = (state: IDrawPredictorStore) => state.projectJsons.settings;
export const getFanFacts = (state: IDrawPredictorStore) => state.projectJsons.fanFacts;
export const getQualifierGroups = (state: IDrawPredictorStore) =>
	state.projectJsons.qualifierGroups;
export const getFanFactBySquadId = createSelector(
	getFanFacts,
	getFanFactSquadId,
	(facts, squadId: number) => {
		if (!squadId) {
			return "";
		}

		const factsForSquad = facts[squadId];

		if (!factsForSquad) {
			return "";
		}
		const randIndex = factsForSquad.length > 1 ? random(factsForSquad.length) : 0;
		return factsForSquad[randIndex];
	}
);

export const getProjectJSONRequestState = (state: IDrawPredictorStore) =>
	state.projectJsons.requests;

export const getSettingsJSONRequestState = createSelector(
	getProjectJSONRequestState,
	(states) => states.settings
);

export const getQualifierGroupsJSONRequestState = createSelector(
	getProjectJSONRequestState,
	(states) => states.qualifierGroups
);
export const getQualifierSquadsJSONRequestState = createSelector(
	getProjectJSONRequestState,
	(states) => states.qualifierSquads
);

export const isSettingsJSONReceived = createSelector(
	getSettingsJSONRequestState,
	(state) => state === RequestState.Received
);

export const isQualifierGroupsJSONReceived = createSelector(
	getQualifierGroupsJSONRequestState,
	(state) => state === RequestState.Received
);
export const isQualifierSquadsJSONReceived = createSelector(
	getQualifierSquadsJSONRequestState,
	(state) => state === RequestState.Received
);

export const isQualifierJSONsReceived = createSelector(
	isQualifierGroupsJSONReceived,
	isQualifierSquadsJSONReceived,
	(groupsLoaded, squadsLoaded) => groupsLoaded && squadsLoaded
);

export const getQualifierSquads = (state: IDrawPredictorStore) => {
	return state.projectJsons.qualifierSquads;
};

export const getQualifierSquadsById = createSelector(getQualifierSquads, (squads) =>
	keyBy(squads, "id")
);
